import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect } from "react";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import TNCHeader from "../Components/TermsAndConditionsComps/TNCHeader";
import TNCOverview from "../Components/TermsAndConditionsComps/TNCOverview";
import ColorHelper from "../Helpers/ColorHelper";
import FontHelper from "../Helpers/FontHelper";
import PrivacyHeader from "../Components/PrivacyPolicy/PrivacyHeader";
import PrivacyOverview from "../Components/PrivacyPolicy/PrivacyOverview";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy";
    window.scrollTo(0, 100);
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <Header />
      <Box sx={{ px: { xs: 2, md: 15 }, py: 5 }}>
        <PrivacyHeader />
        <PrivacyOverview />
      </Box>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;
